import { useState } from 'react';
import {
  fetchChats,
  TChat,
  TFetchChats,
} from 'utils/hooks/useChats/fetchChats';

function useChats() {
  const [data, setData] = useState<TChat | null>(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getChats = async (payload: TFetchChats) => {
    setIsError(false);
    setIsLoading(true);
    await fetchChats(payload)
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch(() => {
        setData(null);
        setIsError(true);
        setIsLoading(false);
      });
  };

  return {
    data,
    getChats,
    isError,
    isLoading,
  };
}

export default useChats;
